import { useState, useEffect, useCallback } from 'react';
import { sb } from '../../lib/supabase';
import { useSupabaseAuth, useAccess } from '../../context/AuthContext';
import Loader from '../../components/Loader';
import ReferenceDataShell from '../../components/admin/ReferenceData';

export default function ReferenceData() {
  const { profile } = useSupabaseAuth();
  const { isAdmin } = useAccess();
  const orgId = profile?.organisation_id;

  const [lookups, setLookups] = useState({
    departments: [], teams: [], subTeams: [], suppliers: [], skills: [], countries: [], fx: [],
  });
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!orgId) { setLoading(false); return; }
    setLoading(true);
    try {
      const [departments, teams, subTeams, suppliers, skills, countries, fx] = await Promise.all([
        sb.from('functions').select('*').eq('organisation_id', orgId).order('name'),
        sb.from('resource_teams').select('*').eq('organisation_id', orgId).order('name'),
        sb.from('resource_sub_teams').select('*').eq('organisation_id', orgId).order('name'),
        sb.from('resource_suppliers').select('*').eq('organisation_id', orgId).order('name'),
        sb.from('resource_skills').select('*').eq('organisation_id', orgId).order('name'),
        sb.from('resource_countries').select('*').eq('organisation_id', orgId).order('name'),
        sb.from('resource_fx_rates').select('*').eq('organisation_id', orgId).order('effective_date', { ascending: false }),
      ]);
      setLookups({
        departments: departments.data || [],
        teams: teams.data || [],
        subTeams: subTeams.data || [],
        suppliers: suppliers.data || [],
        skills: skills.data || [],
        countries: countries.data || [],
        fx: fx.data || [],
      });
    } catch (e) {
      console.error('[ReferenceData] load failed', e);
    } finally {
      setLoading(false);
    }
  }, [orgId]);

  useEffect(() => { load(); }, [load]);

  if (loading) return <Loader text="Loading reference data…" />;

  if (!isAdmin) {
    return (
      <div className="content">
        <div className="empty" style={{ marginTop: 40 }}>Company admin access required.</div>
      </div>
    );
  }

  return (
    <div className="content" style={{ padding: 0, display: 'flex', flexDirection: 'column', minHeight: 0, flex: 1 }}>
      <ReferenceDataShell lookups={lookups} orgId={orgId} profile={profile} reload={load} />
    </div>
  );
}
